import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { MdClose, MdSearch } from 'react-icons/md'
import CallContacts from './CallContacts'
import { resetSearchText, setSearchText } from '../../redux/reducers/searchSlice'

import styles from './CallContactPicker.module.scss'

// Searchable contact list shown in the global modal for in-call actions
// (Add / Transfer), same as iOS ContactsViewController in `inCallMode`.
const CallContactPicker = ({ title, onSelect, onClose }) => {
  const dispatch = useDispatch()
  const inputRef = useRef(null)

  useEffect(() => {
    dispatch(resetSearchText())
    inputRef.current?.focus()
    return () => {
      dispatch(resetSearchText())
    }
  }, [dispatch])

  const handleFilterContacts = (e) => {
    dispatch(setSearchText(e.target.value.toLowerCase()))
  }

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <span className={styles.title}>{title}</span>
        <div className={styles.searchInputWrapper}>
          <input
            type='text'
            onChange={handleFilterContacts}
            placeholder='Search'
            className={styles.input}
            ref={inputRef}
          />
          <MdSearch className={styles.icon} />
        </div>
        <span className={styles.closeIcon} onClick={onClose}>
          <MdClose />
        </span>
      </header>
      <div className={styles.list}>
        <CallContacts handleTransferCall={onSelect} />
      </div>
    </div>
  )
}

CallContactPicker.propTypes = {
  title: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default CallContactPicker
